import { Outlet, useLocation } from 'react-router-dom';
import Forbidden from '@/modules/Forbidden';
import { hasRoutePermission } from '@/router/route-permissions';
import useAuthStore from '@/store/auth/auth.store';

/**
 * PermissionGuard wraps routes and checks if the user has permission
 * to access the current route. Shows Forbidden page if access is denied.
 */
const PermissionGuard = () => {
  const { pathname } = useLocation();
  const { userPermissions, userInfo } = useAuthStore();

  // If user info is not loaded yet, let the content render (useRouterGuard handles auth)
  if (!userInfo) {
    return <Outlet />;
  }

  // Check if user has permission to access this route
  const hasPermission = hasRoutePermission(pathname, userPermissions);

  if (!hasPermission) {
    return <Forbidden />;
  }

  return <Outlet />;
};

export default PermissionGuard;
